import { localDateKey } from './scanSessionCache';

export const HARD_REFRESH_DAY_KEY = 'wmsHardRefreshDay';
const HARD_REFRESH_PARAM = '_wmsRefresh';

/**
 * On the first authenticated load of a local calendar day, reloads with a cache-busting
 * query so `index.html` and its hashed bundles are fetched fresh from the server.
 * Returns true when the reload has started; the caller should keep the loading screen up.
 */
export function startDailyHardRefresh(now: Date = new Date()): boolean {
  if (!import.meta.env.PROD) {
    return false;
  }
  const today = localDateKey(now);
  try {
    if (localStorage.getItem(HARD_REFRESH_DAY_KEY) === today) {
      return false;
    }
    localStorage.setItem(HARD_REFRESH_DAY_KEY, today);
    // Without a persisted stamp the reloaded page would refresh again, forever.
    if (localStorage.getItem(HARD_REFRESH_DAY_KEY) !== today) {
      return false;
    }
  } catch {
    return false;
  }
  const url = new URL(window.location.href);
  url.searchParams.set(HARD_REFRESH_PARAM, String(now.getTime()));
  window.location.replace(url.toString());
  return true;
}

/** Removes the cache-busting query from the address bar. Run before the router mounts. */
export function stripHardRefreshParam(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(HARD_REFRESH_PARAM)) {
    return;
  }
  url.searchParams.delete(HARD_REFRESH_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

/** `localStorage.clear()` that keeps today's refresh stamp, so signing in again the same day does not reload. */
export function clearLocalStorageKeepingRefreshDay(): void {
  const stamp = localStorage.getItem(HARD_REFRESH_DAY_KEY);
  localStorage.clear();
  if (stamp) {
    localStorage.setItem(HARD_REFRESH_DAY_KEY, stamp);
  }
}
